import { FieldExtraOption, FormatedFields } from "../types/fields.types";
import { UnknownItems } from "../types/items.types";
import { removeFields } from "./formatFields";
import { FieldsToRemoveType } from "./formatFields";

export type Group = {
    groupName: string;
    groupId: string;
    hidden?: boolean;
    fields: FormatedFields;
};
export type Groups = Array<Group>;

export function formatGroups(fields: FormatedFields, item: UnknownItems, type: string, fieldsWithExtraOptions?: Array<FieldExtraOption>) {
    let fieldsToRemove: FieldsToRemoveType = {
        fieldNamesToRemove: [],
    };
    if (type === "update") {
        fieldsToRemove.fieldNamesToRemove = ["user_created", "user_updated", "sort", "date_updated", "id"];
    } else {
        fieldsToRemove.fieldNamesToRemove = [ "sort"];
    }

    const newFields = removeFields(fields, fieldsToRemove);
    
    if (!newFields) return { type: "groups", groups: [] };

    const groups: Groups = newFields.reduce((acumulater, current) => {
        if (current.settings.isGroup) {
            const groupOption = fieldsWithExtraOptions?.find((option) => option.field === current.field);
            const { field, hidden, ...overrides } = groupOption || {};

            acumulater.push({
                groupName: current.headerName || "",
                groupId: current.field,
                hidden: typeof hidden === "boolean" ? hidden : current.settings.hidden,
                fields: [],
                ...overrides,
            });
        }
        return acumulater;
    }, [] as Groups);

    newFields.forEach((field) => {
        groups.forEach((group) => {
            if (field.settings.group === group.groupId) {
                group.fields.push(field);
            }
        });
    });

    return { type: "groups", groups: groups };
}

